import React, { useState, useEffect } from 'react';
import { onGameEvent } from '../../core/GameEvents';
import {
  PALETTE,
  stationContainerStyle,
  StationHeader,
  StationFooter,
  Card,
  SectionTitle,
  Hint,
  primaryBtnStyle,
} from './stationTheme';

interface RepairBayProps {
  stationId: string;
  onBack: () => void;
}

export function RepairBay({ stationId, onBack }: RepairBayProps) {
  const [hull, setHull] = useState(100);
  const [maxHull, setMaxHull] = useState(100);

  useEffect(() => {
    const unsub = onGameEvent('playerStateUpdate', (state) => {
      setHull(state.hull);
      setMaxHull(state.maxHull);
    });
    return unsub;
  }, []);

  const hullPercent = maxHull > 0 ? (hull / maxHull) * 100 : 0;
  const needsRepair = hull < maxHull;
  const hullColor = hullPercent > 50 ? PALETTE.GREEN : hullPercent > 25 ? PALETTE.ORANGE : PALETTE.RED;

  return (
    <div style={stationContainerStyle}>
      <StationHeader onBack={onBack} title="REPAIR BAY" hint="[ESC] Return to Station" />

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 20, padding: 20 }}>
        <Card style={{ textAlign: 'center', maxWidth: 320, width: '100%' }}>
          <SectionTitle style={{ textAlign: 'center' }}>HULL STATUS</SectionTitle>
          <div style={{ fontSize: 24, color: hullColor, fontWeight: 600 }}>
            {Math.round(hull)} / {Math.round(maxHull)}
          </div>
          <div style={{
            width: 200,
            height: 20,
            backgroundColor: PALETTE.DARK,
            borderRadius: 4,
            overflow: 'hidden',
            margin: '8px auto 0',
          }}>
            <div style={{
              width: `${hullPercent}%`,
              height: '100%',
              backgroundColor: hullColor,
              transition: 'width 0.3s ease',
            }} />
          </div>
        </Card>

        {needsRepair ? (
          <button
            style={primaryBtnStyle(false)}
            onClick={() => {
              // TODO: Call repair API
            }}
          >
            REPAIR HULL
          </button>
        ) : (
          <div style={{ color: PALETTE.GREEN, fontSize: 13 }}>Hull at full capacity</div>
        )}

        <Hint>Full repair functionality coming soon...</Hint>
      </div>

      <StationFooter>Repair your ship hull and systems</StationFooter>
    </div>
  );
}

export default RepairBay;
